import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useNavigate, useParams } from "react-router-dom"
import { BaseUrl } from '../../helper/BaseUrl';
import { DateConvert } from '../../helper/DateConvert';
import { Accordion } from 'react-bootstrap'
import GlobalFaq from "../GlobalFaq";
export default function BlogDetailArticle({ initialData, data }) {
  const { slug } = useParams();
  const [aiData, setAiData] = React.useState(initialData || {});
  const [pageUrl, setPageUrl] = React.useState("");
  const [copied, setCopied] = React.useState(false);
  const [activeSection, setActiveSection] = useState(0);

  const navigate = useNavigate();
  React.useEffect(() => {
    if (typeof window !== "undefined") {
      setPageUrl(window.location.href);
    }
  }, []);
  const handleCopy = async () => {
    if (typeof window !== "undefined" && pageUrl) {
      try {
        await navigator.clipboard.writeText(pageUrl);
        setCopied(true);
        setTimeout(() => setCopied(false), 10000); // reset after 10s
      } catch (err) {
        console.error("Copy failed:", err);
      }
    }
  };
  const aifetcher = async () => {
    try {
      const response = await fetch(`${BaseUrl}/api/blog/view/${slug}`, {
        method: 'GET',
      });
      const result = await response.json();
      if (result.blog === false) {
        navigate("/404");
        throw new Error(`API error: ${result.message}`);
      }
      setAiData(result.blog);
    } catch (error) {
      console.error('Fetch error:', error.message);
    }
  };
  React.useEffect(() => {
    aifetcher();
  }, [slug])
  const handleScroll = (id, index) => {
    setActiveSection(index);

    const element = document.getElementById(id);

    if (element) {
      const yOffset = -90;
      const y =
        element.getBoundingClientRect().top +
        window.pageYOffset +
        yOffset;

      window.scrollTo({
        top: y,
        behavior: "smooth",
      });
    }
  };

  const encodedUrl = encodeURIComponent(pageUrl);
  const encodedTitle = encodeURIComponent(aiData?.title || "");

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  }, [slug]);


  return (
    <>
      <article className="blog-detail-article">
        <div className="container">
          <nav className="blog-detail-breadcrumbs" aria-label="Breadcrumb">
            <Link to="/">Home</Link>
            <span>|</span>
            <Link to="/blogs">Blog</Link>
            <span>|</span>
            <span> {aiData?.title ? aiData.title.slice(0, 20) + "..." : ""}</span>
          </nav>

          <h1 className="heading"> {aiData?.title}</h1>
          <div className="blog-detail-meta">
            <div className="blog-detail-author">
              <img src={aiData?.author_image ? BaseUrl + aiData?.author_image : "/assets/images/author-images.webp"} alt={aiData?.author_name} className="img-responsive" />
              <div>
                <p>  Written by <strong>{aiData?.author_name}</strong>  </p>
                <span>{DateConvert(aiData?.date)}</span>
              </div>
            </div>

            <div className="blog-detail-socials" aria-label="Share this article">
              <button type="button"
                className="blog-social-link blog-social-copy" onClick={handleCopy} aria-label="Copy article link" title={copied ? "Copied!" : "Copy link"} >
                <i className="fa-solid fa-link" />
              </button>
              <a className="blog-social-link blog-social-facebook"
                href={`https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`} target="_blank" rel="noreferrer" aria-label="Share on Facebook">
                <i className="fa-brands fa-facebook-f" />
              </a>
              <a className="blog-social-link blog-social-linkedin"
                href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`} target="_blank" rel="noreferrer" aria-label="Share on LinkedIn" >
                <i className="fa-brands fa-linkedin-in" />
              </a>
              <a
                className="blog-social-link blog-social-x"
                href={`https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`} target="_blank" rel="noreferrer" aria-label="Share on X" >
                <i className="fa-brands fa-x-twitter" />
              </a>
            </div>
          </div>
          <img src={aiData?.banner_image ? BaseUrl + aiData.banner_image : undefined} className="blog-detail-featured-image" alt={aiData?.title} />
          <div className="blog-detail-content-layout">
            <aside className="blog-detail-toc">
              <p>Introduction</p>
              <ul>
                {aiData?.full_description?.map((data, index) => (
                  <li key={index}>
                    <a href={`#section-${index}`}
                      className={`blog-detail-toc-link ${activeSection === index ? "active" : ""}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleScroll(`section-${index}`, index);
                      }} >
                      {data?.heading?.length > 40
                        ? data.heading.slice(0, 40) + "..."
                        : data.heading}
                    </a>
                  </li>
                ))}
              </ul>
            </aside>

            <div className="blog-detail-content">
              <div dangerouslySetInnerHTML={{ __html: aiData?.introduction }} />
              {aiData?.full_description && aiData?.full_description?.map((data, index) => (
                <div key={index}>
                  <h2 className="heading" id={`section-${index}`}> {data?.heading}  </h2>
                  <div dangerouslySetInnerHTML={{ __html: data?.description }} />
                  {index === 1 && aiData?.image1 && (
                    <div className="ai-blog-wrap">  <img src={aiData?.image1 ? BaseUrl + aiData.image1 : undefined} alt={aiData?.alt_image1} className="img-responsive" loading="lazy" />  </div>
                  )}
                </div>
              ))}
              {aiData?.reference &&
                <div className="reference-wrap">
                  <Accordion id="references">
                    <Accordion.Item eventKey="0">
                      <Accordion.Header as={"h2"}>{"References"}</Accordion.Header>
                      <Accordion.Body>
                        <div dangerouslySetInnerHTML={{ __html: aiData?.reference }} />
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>
              }
              <div className="blog-faq-wrapper">
                <GlobalFaq />
                </div>
            </div>
          </div>
        </div>
      </article>

      <section className="blog-related-section">
        <div className="container">
          <h2 className="heading text-center">You Might Also Be Interested In</h2>
          <div className="row blog-related-cards">
            {data.map((item, index) => (
              <div className="col-lg-4" key={index}>
                <article className="blog-related-card">
                  <img src={item?.thumbnail ? `${BaseUrl}${item.thumbnail}` : undefined} className="img-responsive" alt={item?.alt_thumbnail} loading="lazy" />
                  <p>{DateConvert(item?.date)}</p>
                  <h3 >  {item?.title?.slice(0, 40) + "..."}  </h3>
                  <span> {item?.brief?.slice(0, 75) + "..."} </span>
                  <Link to={`/blogs/${item.slug}`}>
                    Read More <i className="fa-solid fa-arrow-right" />
                  </Link>
                </article>
              </div>
            ))}
          </div>
          <div className="blog-related-cta text-center">
            <Link to={"/blogs"} className="default-btn">
              View More
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
